import { serialize } from 'object-to-formdata';

import { IBaseModel } from 'src/model/BaseModel';

import { toApi } from './utils';

export default (data: any, Model: IBaseModel) =>
  serialize(toApi(data, Model.toApi));
